var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      model: {
        value: _vm.showModal,
        callback: function($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal"
      }
    },
    [
      _c("div", { attrs: { slot: "modal-title" }, slot: "modal-title" }, [
        _vm._v(
          "\n    " +
            _vm._s(_vm.$t("message.booking.checkout_step.invite_friends")) +
            "\n  "
        )
      ]),
      _vm._v(" "),
      _c("section", [
        _c("p", { staticClass: "text-comment" }, [
          _vm._v(
            "\n      " +
              _vm._s(
                _vm.$t("message.invite_friends.receive_credit_detail", {
                  credits: _vm.globalState.configData.invite_friend_credits
                })
              ) +
              "\n    "
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "mt-4" }, [
          _c("h3", [
            _vm._v(_vm._s(_vm.$t("message.invite_friends.how_do_invites_work")))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row mt-4" }, [
          _c("div", { staticClass: "col-2" }, [
            _c("i", { staticClass: "fal fa-link fa-3x -status-pending" })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-10" }, [
            _c("h4", [
              _vm._v(
                _vm._s(
                  _vm.$t("message.invite_friends.how_do_invites_work_title01")
                )
              )
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "text-comment" }, [
              _vm._v(
                _vm._s(
                  _vm.$t("message.invite_friends.how_do_invites_work_detail01")
                )
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row mt-4" }, [
          _c("div", { staticClass: "col-2" }, [
            _c("i", {
              staticClass: "fal fa-hand-holding-usd fa-3x -status-new"
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-10" }, [
            _c("h4", [
              _vm._v(
                _vm._s(
                  _vm.$t("message.invite_friends.how_do_invites_work_title02", {
                    credits: _vm.globalState.configData.register_credits
                  })
                )
              )
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "text-comment" }, [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "message.invite_friends.how_do_invites_work_detail02",
                    { credits: _vm.globalState.configData.register_credits }
                  )
                )
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row mt-4" }, [
          _c("div", { staticClass: "col-2" }, [
            _c("i", { staticClass: "fal fa-piggy-bank fa-3x -status-new" })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-10" }, [
            _c("h4", [
              _vm._v(
                _vm._s(
                  _vm.$t("message.invite_friends.how_do_invites_work_title03", {
                    credits: _vm.globalState.configData.invite_friend_credits
                  })
                )
              )
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "text-comment" }, [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "message.invite_friends.how_do_invites_work_detail03",
                    {
                      credits: _vm.globalState.configData.invite_friend_credits
                    }
                  )
                )
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _vm.referralCode
          ? _c("div", { staticClass: "row mt-4 no-gutters" }, [
              _c("div", { staticClass: "col-12" }, [
                _c("h3", [
                  _vm._v(
                    _vm._s(_vm.$t("message.invite_friends.share_your_link"))
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "input-group flex-fill" }, [
                  _c("input", {
                    ref: "referralCode",
                    staticClass: "form-control flex-fill",
                    attrs: { type: "text" },
                    domProps: {
                      value:
                        "beneat.co/chat-booking?c=" +
                        _vm.referralCode.referral_code
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "input-group-append" }, [
                    _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "clipboard",
                            rawName: "v-clipboard:copy",
                            value: _vm.referralCode.url_referral_code,
                            expression: "referralCode.url_referral_code",
                            arg: "copy"
                          }
                        ],
                        staticClass: "btn btn-info",
                        on: {
                          click: function($event) {
                            return _vm.copyReferralCode()
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t(_vm.isCopiedReferralCode)) +
                            "\n            "
                        )
                      ]
                    )
                  ])
                ])
              ])
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "w-100",
          attrs: { slot: "modal-footer" },
          slot: "modal-footer"
        },
        [
          _c(
            "b-btn",
            {
              staticClass: "float-right",
              attrs: { variant: "secondary" },
              on: {
                click: function($event) {
                  _vm.showModal = false
                }
              }
            },
            [
              _vm._v(
                "\n      " + _vm._s(_vm.$t("message.button.close")) + "\n    "
              )
            ]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-75f6e4da", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75f6e4da","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/booking/components/InviteFriendModal.vue
// module id = 1685
// module chunks = 0